// src/components/ui/Panel.jsx — premium v8.3
import Card from "./Card";

export default function Panel({ children, className = "", variant = "elevated", compact = false, style = {} }) {
  return (
    <Card variant={variant} className={className} style={{ padding: compact ? "14px 16px" : "20px 24px", ...style }}>
      {children}
    </Card>
  );
}
